/**
 * ジアン・GIEN商品の詳細ページ: ジアンのコレクションページの
 * 「ジアン年間人気ランキングTOP50」「バイヤーおすすめ」を、そのまま読み込んで表示する。
 *
 * ・内容は /collections/gien の同じセクションから取得するため、ジアンのページを更新すれば自動で反映される
 * ・取得できなかった場合は、何も表示しない（商品ページの他の表示には影響しない）
 * ・同じ閲覧中は結果を10分間だけ保存して、読み込みを速くする
 */
(function () {
  'use strict';

  var container = document.querySelector('[data-gien-embed]');
  if (!container) return;

  var SOURCE = container.getAttribute('data-source') || '/collections/gien';
  var CACHE_KEY = 'gien-product-embed-v1';
  var CACHE_TTL = 10 * 60 * 1000;

  // 読み込む対象（ジアンのコレクションページ内のセクションのid接頭辞）
  var TARGET_ID_PREFIXES = ['gien-ranking-', 'gien-buyer-picks-'];

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.parts || !data.parts.length) return null;
      if (Date.now() - data.time > CACHE_TTL) return null;
      return data.parts;
    } catch (e) {
      return null;
    }
  }

  function writeCache(parts) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), parts: parts }));
    } catch (e) {
      /* 保存できなくても問題なし */
    }
  }

  // 商品ページでは英語の見出しとスラッシュを出さず、日本語のみ（サイト共通の見出しデザイン）にする
  function makeHeadingsJapaneseOnly(root) {
    root.querySelectorAll('.c-main__title-box').forEach(function (box) {
      box.classList.add('-jp-only');
      box.querySelectorAll('.-title, .-slash').forEach(function (el) {
        el.parentNode.removeChild(el);
      });
    });
  }

  // innerHTML で追加した <script> は動かないため、作り直して実行する
  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (oldScript) {
      var script = document.createElement('script');
      if (oldScript.src) {
        script.src = oldScript.src;
      } else {
        script.text = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  // お気に入りボタン(Swym)を、追加した商品カードでも使えるようにする
  function initWishlistButtons() {
    try {
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons('.gien-product-embed');
      }
    } catch (e) {
      /* お気に入りボタンが使えなくても、表示には影響しない */
    }
  }

  function render(parts) {
    container.innerHTML = parts.join('');
    makeHeadingsJapaneseOnly(container);
    runScripts(container);
    initWishlistButtons();
    container.classList.add('is-loaded');
  }

  function extractParts(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var parts = [];
    TARGET_ID_PREFIXES.forEach(function (prefix) {
      var el = doc.querySelector('[id^="' + prefix + '"]');
      if (!el) return;
      var wrapper = el.closest('.shopify-section') || el;
      parts.push(wrapper.outerHTML);
    });
    return parts;
  }

  var cached = readCache();
  if (cached) {
    render(cached);
    return;
  }

  fetch(SOURCE, { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    })
    .then(function (html) {
      var parts = extractParts(html);
      if (!parts.length) return;
      writeCache(parts);
      render(parts);
    })
    .catch(function (error) {
      if (window.console) console.warn('ジアンの共通セクションを読み込めませんでした', error);
    });
})();
